import { GALLERY } from "../data/content";
import { SectionHeader } from "./SectionHeader";
import { Reveal } from "./Reveal";

export const Gallery = () => (
    <section
        id="galeri"
        data-testid="galeri-section"
        aria-labelledby="galeri-title"
        className="bg-bh-offwhite py-24 sm:py-32 scroll-mt-20"
    >
        <div className="max-w-[1565px] mx-auto">
            <SectionHeader
                eyebrow={GALLERY.eyebrow}
                title={GALLERY.title}
                testid="galeri-title"
            />
            <div className="px-6 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {GALLERY.categories.map((category, i) => (
                    <Reveal key={category.image} delay={(i % 3) * 0.1}>
                        <figure>
                            <div
                                data-testid={`gallery-item-${i + 1}`}
                                role="img"
                                aria-label={category.title}
                                className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-bh-green/15 bg-bh-light"
                            >
                                <img
                                    src={category.image}
                                    alt=""
                                    aria-hidden="true"
                                    className="absolute inset-0 h-full w-full object-cover"
                                    loading="lazy"
                                    onError={(event) => {
                                        const image = event.currentTarget;
                                        if (image.dataset.fallbackApplied) return;
                                        image.dataset.fallbackApplied = "true";
                                        image.src = "/assets/pengurus/foto-placeholder-pengurus.webp";
                                    }}
                                />
                            </div>
                            <figcaption className="mt-3 text-sm font-semibold text-bh-deep text-center">
                                {category.title}
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
